import React, { useState, useRef } from 'react';
import './style.scss';
import parse from 'html-react-parser';

interface Props {
    errorTitle: any,
    errorInfo: any
}

const ErrorComponent: React.FC<any> = ({ errorTitle, errorInfo }) => {
    const [isOpened, setIsOpened] = useState(false);
    const ref: any = useRef(null);
    const copyValue = errorTitle + ' ' + errorInfo.componentStack;

    const copyError = (e: any) => {
        ref.current.select();
        document.execCommand('copy');
        e.target.focus();
    }

    return (
        <div className="errorComponent">
            <div className="wrapper">
                <h1>Oops! Something went wrong.</h1>
                <div className="error-wrapper">
                    <button className="reload default-error" onClick={() => { window.location.reload() }}><p>Reload page</p></button>
                    <button className="details-btn" onClick={() => { setIsOpened(!isOpened) }}>
                        {isOpened ? 'Hide' : 'Show'} details</button>
                    {
                        isOpened && <div className="details-block" style={{ whiteSpace: "pre-wrap" }}>
                            <p><b>{errorTitle && errorTitle}</b></p>
                            <p>{errorInfo && errorInfo.componentStack}</p>
                            <textarea className={'copyTextarea'} ref={ref} value={copyValue} />
                            <button className="copy" onClick={copyError}>Copy to clipboard</button>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export const ConfigErrorComponent: React.FC<any> = () => {
    return (
        <div className="errorComponent">
            <div className="wrapper">
                <h1>Oops! Something went wrong.</h1>
                <p>
                    <span className="mrg-bot">Cannot start Qognify Web Client.&nbsp;</span>

                    Please check <span className="path">{parse(window.VARIABLES.configPath)}config.js</span>
                </p>
                <button className="reload" onClick={() => { window.location.reload() }}><p>Reload page</p></button>
            </div>
        </div>
    );
}

export { ErrorComponent as default };